<template>
  <div class="row">
    <div class="col-md-12">
      <h1 class="h3 mb-3 text-gray-800">{{ $t("Editar Usuário") }}</h1>
    </div>
    <load v-if="loading"
          message="Carregando informações do usuário"/>
    <div v-else
         class="col-md-12">
      <div class="row"
           v-if="item">
        <div class="col-md-12">
          <header-usuario
              :item="item"
              @show-exclusao="$bvModal.show('modal-usuario-excluida')"
          />
        </div>
      </div>
      <div class="row"
           v-if="item">
        <div
            class="col-md-12"
            v-if="item.situacao && item.situacao.status == '1'"
        >
          <b-alert show
                   dismissible>
            Você está realizando o <b>cadastro/edição</b> de um
            <b>Usuário/Família</b> em Situação de Rua.<br/>
            Recomendamos que preencha o máximo de campos possíveis nas abas
            Situação de Rua e Saúde<br/>
            <b-button
                variant="success"
                size="sm"
                class="mt-3"
                @click.prevent="redirectAtendimentos"
            >
              Cadastrar Atendimento
            </b-button>
          </b-alert>
        </div>
      </div>
      <div class="row d-flex align-items-stretch pl-3"
           v-if="item">
        <div class="col-md-3 card p-0 shadow card-body rounded border">
          <div class="list-group w-100 h-100 p-b">
            <a
                href="#"
                v-for="(item, i) in menu"
                :key="i"
                @click="page = item.tab"
                :class="page == item.tab ? 'active' : ''"
                class="list-group-item list-group-item-action"
            >
              {{ item.titulo }}
            </a>
            <b-link
                :to="`/dashboard/usuarios/imprimir/${item.id}`"
                class="list-group-item list-group-item-action"
            >
              Visualizar e Imprimir
            </b-link
            >
          </div>
        </div>
        <div class="col-md-9">
          <div class="card shadow card-body tab-content rounded border">
            <div
                class="tab-pane animate__animated animate__fadeIn"
                :class="page == 'identificacao' ? 'active' : ''"
                v-if="page == 'identificacao'"
            >
              <Identificacao @submit="submit"
                             @excluir="excluir"
                             :item="item"/>
            </div>
            <div
                class="tab-pane animate__animated animate__fadeIn"
                :class="page == 'escolaridade' ? 'active' : ''"
                v-if="page == 'escolaridade'"
            >
              <Escolaridade @submit="submit"
                            :item="item"/>
            </div>
            <div
                class="tab-pane animate__animated animate__fadeIn"
                :class="page == 'saude' ? 'active' : ''"
                v-if="page == 'saude'"
            >
              <Saude @submit="submit"
                     :item="item"/>
            </div>
            <div
                class="tab-pane animate__animated animate__fadeIn"
                :class="page == 'pendencias' ? 'active' : ''"
                v-if="page == 'pendencias'"
            >
              <Pendencia @submit="submit"
                         :item="item"/>
            </div>
            <div
                class="tab-pane animate__animated animate__fadeIn"
                :class="page == 'anexos' ? 'active' : ''"
                v-if="page == 'anexos'"
            >
              <Anexo @submit="submit"
                     :item="item"/>
            </div>
            <div
                class="tab-pane animate__animated animate__fadeIn"
                :class="page == 'aspecto' ? 'active' : ''"
                v-if="page == 'aspecto'"
            >
              <Aspecto @submit="submit"
                       :item="item"/>
            </div>
            <div
                class="tab-pane animate__animated animate__fadeIn"
                :class="page == 'lazer' ? 'active' : ''"
                v-if="page == 'lazer'"
            >
              <LazerCultura @submit="submit"
                            :item="item"/>
            </div>
            <div
                class="tab-pane animate__animated animate__fadeIn"
                :class="page == 'documento' ? 'active' : ''"
                v-if="page == 'documento'"
            >
              <Documento @submit="submit"
                         :item="item"/>
            </div>
            <div
                class="tab-pane animate__animated animate__fadeIn"
                :class="page == 'ocupacao' ? 'active' : ''"
                v-if="page == 'ocupacao'"
            >
              <TrabalhoRemuneracao @submit="submit"
                                   :item="item"/>
            </div>
            <div
                class="tab-pane animate__animated animate__fadeIn"
                :class="page == 'situacao' ? 'active' : ''"
                v-if="page == 'situacao'"
            >
              <SituacaoRua @submit="submit"
                           :item="item"/>
            </div>
            <div
                class="tab-pane animate__animated animate__fadeIn"
                :class="page == 'historicoscfv' ? 'active' : ''"
                v-if="page == 'historicoscfv'"
            >
              <HistoricoScfv :item="item"/>
            </div>

            <div
                class="tab-pane animate__animated animate__fadeIn"
                :class="page == 'historicoatividades' ? 'active' : ''"
                v-if="page == 'historicoatividades'"
            >
              <HistoricoAtividades :item="item"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <excluir-usuario
        :item="item"
        @reload="getUsuario"
        @cancelado="
        item.estado_cadastral_cadunico = parseInt(item.estado_cadastral_id)
      "
    />

    <ModalUsuarioExcluido :item="item"/>
  </div>
</template>
<script>
import Documento from "./includes/Abas/Documento";
import Escolaridade from "./includes/Abas/Escolaridade";
import Identificacao from "./includes/Abas/Identificacao";
import Informacao from "./includes/Abas/Informacao";
import TrabalhoRemuneracao from "./includes/Abas/TrabalhoRemuneracao";
import Saude from "./includes/Abas/Saude";
import SituacaoRua from "./includes/Abas/SituacaoRua";
import Anexo from "./includes/Abas/Anexo";
import Pendencia from "./includes/Abas/Pendencia";
import Aspecto from "./includes/Abas/Aspecto";
import LazerCultura from "./includes/Abas/LazerCultura";
import HistoricoScfv from "./includes/Abas/HistoricoScfv";
import ModalUsuarioExcluido from "./includes/ModalUsuarioExcluido";
import HistoricoAtividades from "./includes/Abas/HistoricoAtividades.vue";

export default {
  name: "Edit",
  components: {
    HistoricoAtividades,
    Aspecto,
    Anexo,
    Pendencia,
    Documento,
    Escolaridade,
    Identificacao,
    Informacao,
    LazerCultura,
    TrabalhoRemuneracao,
    Saude,
    SituacaoRua,
    HistoricoScfv,
    ModalUsuarioExcluido,
  },
  data() {
    return {
      loading: true,
      item: [],
      cidades: [],
      estados: [],
      page: "identificacao",
      menu: [
        {tab: "identificacao", titulo: "Identificação do Usuário"},
        {tab: "documento", titulo: "Documentos"},
        {tab: "escolaridade", titulo: "Escolaridade"},
        {tab: "saude", titulo: "Saúde"},
        {tab: "ocupacao", titulo: "Trabalho e Remuneração"},
        {tab: "situacao", titulo: "Situação de Rua"},
        {tab: "pendencias", titulo: "Pendência e Ocorrência"},
        {tab: "anexos", titulo: "Anexo"},
        {tab: "aspecto", titulo: "Aspectos e Situação Familiar"},
        {tab: "lazer", titulo: "Lazer, Cultura e Esporte"},
        // { tab: "informacao", titulo: "Mais Informações" },
        {tab: "historicoscfv", titulo: "Histórico SCFV"},
        {tab: "historicoatividades", titulo: "Histórico Atividades"},
      ],
    };
  },
  mounted() {
    this.$bvModal.show("add-item");
    // if (typeof this.$route.query.item === "object") {
    // 	this.item = this.$route.query.item;
    // 	this.loading = false;
    // } else {

    // }
    this.getUsuario();
    this.getEstados();

    if (this.$route.query.situacao_rua) {
      this.page = "situacao";
    }
  },
  methods: {
    getEstados() {
      axios.get("api/dashboard/enderecos/get/estados").then((response) => {
        this.estados = response.data;
      });
    },
    getUsuario() {
      this.loading = true;
      axios
          .get("api/dashboard/usuarios/" + this.$route.params.id)
          .then((response) => {
            this.$route.query.item = this.item = response.data.data;
          })
          .finally(() => {
            this.loading = false;
          });
    },
    submit() {
      let ladda = Ladda.create(document.querySelector(".btn-submit"));
      ladda.start();
      // this.item.data_nascimento = moment(
      // 	this.item.data_nascimento,
      // 	"YYYY-MM-DD"
      // ).format("DD/MM/YYYY");
      this.loading = true;
      axios
          .put("api/dashboard/usuarios/" + this.item.id, this.item)
          .then((response) => {
            this.item = response.data;
            ladda.stop();
            // this.$snack.success({
            //     button: false,
            //     text: "Dados adicionados corretamente"
            // });
            this.loading = false;
          });
    },
    changeDate(data, mask, format) {
      return moment(data, mask).format(format);
    },
    redirectAtendimentos() {
      this.$router.push("/dashboard/atendimentos/" + this.item.familia_id);
    },
    excluir() {
      swal
          .fire({
            title: "Tem certeza?",
            text: "O usuário não poderá ser vinculado a nenhum serviço.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Sim, exclua!",
            cancelButtonText: "Não",
          })
          .then((result) => {
            if (result.isConfirmed) {
              this.$bvModal.show("modal-excluir-usuario");
            } else {
              this.item.estado_cadastral_cadunico = parseInt(
                  this.item.estado_cadastral_id
              );
            }
          });
    },
  },
};
</script>

<style>
.vs__clear {
  display: none !important;
}

.vs__actions {
  cursor: pointer !important;
}
</style>
